<template>
    <div class="artist">

        <v-container pr-sm-0>
            <v-row class="justify-center justify-md-space-around justify-sm-space-around">
                <v-col :cols="10" lg="6" md="4" sm="5" align-self="start" class="pt-sm-16">
                    <v-row>

                    </v-row>
                    <v-row class="txt-align-left">
                        <v-col>
                            <h3 class="name">{{artists[currentArtist].name}}</h3>
                        </v-col>
                    </v-row>
                    <v-row class="justify-md-space-around">
                        <v-col>
                            <div class="bio">{{artists[currentArtist].bio}}</div>
                        </v-col>

                    </v-row>
                </v-col>
                <v-col  lg="4" md="4" sm="4" class="hidden-xs-only">
                    <v-img 
                        :src="artists[currentArtist].img" 
                        :alt="artists[currentArtist].alt" 
                        :max-height="400"
                        contain
                        >
                    </v-img>

                </v-col>
            </v-row>



            <!-- <v-row class="justify-center justify-space-around">
                <v-col md="4" sm="10" :cols="10" class="mb-10">
                </v-col>
                <v-col lg="5" md="7" sm="10" :cols="12">
                </v-col>
            </v-row>
            <v-row class="justify-center justify-space-around">
                <v-col md="4" sm="10" :cols="10" class="mb-10">
                </v-col>
                <v-col lg="5" md="7" sm="10" :cols="12">
                </v-col>
            </v-row> -->

        </v-container>
    </div>
</template>

<script>

export default {
    name: 'Artist',
    props: ["artists", "currentArtist"],
    computed: {
        getHeight() {
            const {mdAndDown } = this.$vuetify.breakpoint
            return mdAndDown ? 400 : 300
        }
    }
}
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Fauna+One&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap');
    @import '~vuetify/src/styles/settings/_variables.scss';

    .name {
        font-family: 'Teko', sans-serif; 
    }
    .bio {
        font-family: 'Fauna One', serif;
        text-align: left;
    }

    .artist {

        color: #F2EFE8;
        img {
            width: 100px;
        }

        h3 {
            font-size: 2.6rem;
            @media #{map-get($display-breakpoints, 'sm-and-up')} {
                font-size: 3rem;
            }
        }
    }
</style>